// /settings — первый доступный раздел настроек (ux.md «Табеля», раздел 11): у администратора
// клиента — «Компания» (009), у контролёра и ведущего — она же, только для чтения (022), у остальных
// — «Вид»: он есть у любого вошедшего.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQuery } from '../../../shell/session.ts';
import { firstSettingsPath } from '../../../shell/settings-sections.ts';

export const Route = createFileRoute('/_app/_settings/settings/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery());
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- так TanStack Router перенаправляет
    throw redirect({ to: firstSettingsPath(me.permissions), replace: true });
  },
});
